module.exports = __webpack_public_path__ + "static/img/6.f3add14f.png";